import React from 'react';
import styles from '../../../../../styles/widgets/adverts/grid-view.module.scss';
import { Grid } from '../../../../../components/layout/grid';

export const GridView = ({ children }) => (
  <Grid className={styles.grid} fill>
    {children}
  </Grid>
);
